import { motion } from "framer-motion";
import { CalendarDays } from "lucide-react";
import { useLang } from "../context/LanguageContext";

const fade = {
  initial: { opacity: 0, y: 20 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, amount: 0.15 },
  transition: { duration: 0.45 },
};

export const LiveCalendar = ({ schedule }) => {
  const { t, lang } = useLang();
  const loc = lang === "en" ? "en-GB" : "el-GR";

  return (
    <section id="calendar" className="max-w-7xl mx-auto px-5 sm:px-6 pt-20" data-testid="live-calendar">
      <motion.div {...fade}>
        <span className="eyebrow">
          <span className="w-7 h-px bg-[#1D4ED8]" />
          {t("live.calEyebrow")}
        </span>
        <h2 className="font-heading font-black text-3xl sm:text-4xl lg:text-5xl mt-5">{t("live.calTitle")}</h2>
        <p className="text-[#475569] mt-4 max-w-2xl">{t("live.calSubtitle")}</p>
      </motion.div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 mt-10">
        {schedule.map((m, i) => (
          <motion.div
            key={m.month}
            {...fade}
            transition={{ duration: 0.4, delay: Math.min(i, 6) * 0.05 }}
            className="card-dark p-6"
            data-testid={`live-calendar-month-${m.month}`}
          >
            <div className="flex items-center justify-between">
              <p className="font-heading font-black text-lg text-[#0B1B3A] capitalize">
                {new Date(m.year, m.month_number - 1, 1).toLocaleDateString(loc, { month: "long", year: "numeric" })}
              </p>
              <span className="w-9 h-9 rounded-xl bg-[#EEF4FF] grid place-items-center">
                <CalendarDays className="w-4 h-4 text-[#1D4ED8]" />
              </span>
            </div>
            <div className="gold-rule mt-5" />
            <ul className="mt-4 space-y-2.5">
              {m.sessions.map((s) => (
                <li key={s.date} className="flex items-center justify-between text-sm">
                  <span className="font-bold text-[#0B1B3A] capitalize">
                    {new Date(`${s.date}T12:00:00`).toLocaleDateString(loc, { weekday: "short", day: "2-digit", month: "2-digit" })}
                  </span>
                  <span className="text-[#64748B] tabular-nums">{s.from}–{s.to}</span>
                </li>
              ))}
            </ul>
          </motion.div>
        ))}
      </div>
      <p className="text-sm text-[#64748B] mt-6 max-w-2xl">{t("live.calNote")}</p>
    </section>
  );
};
